export const SYSTEM_MODULES = [
    'Dashboard',
    'Obras',
    'Lançamentos',
    'Aportes e Resgates',
    'Recibos',
    'Assinatura Digital',
    'Unidades',
    'Relatórios',
    'Memória de Preço',
    'Calculadoras',
    'Atualização Monetária',
    'INSS de Obra',
    'Categorias',
    'Fornecedores',
    'Investidores',
    'Fases da Obra',
    'Itens',
    'Administração',
    'Módulos',
    'Perfis',
    'Auditoria',
];

export const MODULE_CATEGORY_MAP: Record<string, string> = {
    Dashboard: 'Geral',
    Obras: 'Operacional',
    Unidades: 'Operacional',
    Lançamentos: 'Financeiro',
    'Aportes e Resgates': 'Financeiro',
    Recibos: 'Financeiro & Documentos',
    'Assinatura Digital': 'Financeiro & Documentos',
    Relatórios: 'Análise & Relatórios',
    'Memória de Preço': 'Análise & Relatórios',
    Calculadoras: 'Calculadoras',
    'Atualização Monetária': 'Calculadoras',
    'INSS de Obra': 'Calculadoras',
    Categorias: 'Cadastros',
    Fornecedores: 'Cadastros',
    Investidores: 'Cadastros',
    'Fases da Obra': 'Cadastros',
    Itens: 'Cadastros',
    Administração: 'Administração',
    Módulos: 'Administração',
    Perfis: 'Administração',
    Auditoria: 'Administração',
};
